import type { CampaignStatusFilter } from "../types";

const STATUS_FILTERS: CampaignStatusFilter[] = [
  "all",
  "draft",
  "queued",
  "generating",
  "complete",
  "failed",
  "archived",
];

export function parseCampaignStatusFilter(value: unknown): CampaignStatusFilter {
  return typeof value === "string" && STATUS_FILTERS.includes(value as CampaignStatusFilter)
    ? (value as CampaignStatusFilter)
    : "all";
}

export function parseWizardStep(value: unknown): number {
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= 6 ? parsed : 1;
}
